module.exports = __webpack_public_path__ + "static/media/team-1-800x800.8dedaf01.jpg";